export const InvitationType = Object.freeze({
   VEHICLE: 'Vehicle',
   FACIAL: 'Facial',
   VIRTUAL_KEY: 'VirtualKey',
   QRCODE: 'QrCode',
});

export const getInvitationTypeKey = (value) => Object.entries(InvitationType).find(([k, v]) => v === value)?.[0];

export const InvitationTypeText = Object.freeze({
   [InvitationType.VEHICLE]: 'Veículo',
   [InvitationType.FACIAL]: 'Facial',
   [InvitationType.VIRTUAL_KEY]: 'Chave Virtual',
   [InvitationType.QRCODE]: 'QRCode',
});